import {
    Button,
    Combobox,
    Divider, Dropdown,
    Image,
    Input,
    Label,
    Option,
    Spinner,
    Switch,
    makeStyles, shorthands
} from "@fluentui/react-components";
import {
    DrawerBody,
    DrawerHeader,
    DrawerHeaderTitle,
    DrawerOverlay,
} from "@fluentui/react-components/unstable";
import { DeleteFilled, DeleteRegular, Dismiss24Regular, DocumentRegular, bundleIcon } from "@fluentui/react-icons";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { DateSVG } from "../../static/svgs";
import { Timestamp } from "firebase/firestore";
import { getTimeFromDate, mergeDateTime } from "../../Helper";
import {
    getDownloadURL,
    ref,
    uploadBytesResumable
} from "firebase/storage";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import ServiceProviderDataService from "../../services/ServiceProviderDataService";
import {
    Base_Url,
    apiRegisterWithEmailAndPassword2,
    apiDeleteUserAuth,
    auth,
    getAuthToken,
    storage,
    trackException
} from "../../services/firebase";
import UserDataService from "../../services/userDataService";
import EditPasswordDialogBox from "./EditPasswordDialogBox";
import UpdateEmailDialogBox from "./UpdateEmailDialogBox";
import moment from 'moment';
import axios from "axios";
import { notify } from "../AppNotifications";
import {
    AddressSVG,
    ConnectAccountSVG,
    DrivingLicenceSVG, EyeViewDisableSVG, EyeViewSVG,
    InsuranceSVG,
    PhoneSVG,
    UserFormAddSVG
} from "../../static/svgs";
import "./UserForm.css";
import "./FormStyle.css";

const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);

// The blank member form.
//
// This MUST NOT be handed to react-hook-form, and field values MUST NOT be read
// out of it. It is a module-level singleton: RHF takes `defaultValues` by
// reference and useFieldArray mutates the rows in place, so once a member's phone
// number is typed into a form seeded from this object, the number is written back
// INTO the template and becomes the default for every later form in that browser
// session. A bare reset() then restores it, which is how the previous member's
// number kept appearing on the next new-member form.
//
// Use newUserState() instead — it returns a fresh deep copy every time.
const INITIAL_USER_TEMPLATE = {
    "email": "",
    "firstName": "",
    "lastName": "",
    "phoneNumbers": [{ isPrimary: false, number: "", type: "" }],
    "isAdmin": false,
    "isHonorary": false,
    "memberNumber": "",
    "memberships": [],
    "addOn": [],
    "genderValue": "",
    "address": { city: "", country: "", state: "", street1: "", street2: "", zip: "" },
    "groupIds": [],
    'insuranceImage': '',
    'dlImage': '',
    insuranceInfo: {
        policyHolderName: '',
        insuranceCompany: '',
        policyNumber: '',
        state: ''
    },
    "dLNumber": '',
    "linkedUserIds": [],
    "accountHolderId": '',
    "accessPermission": [],
    "yearlyRequiredSpend": 2000,
    "isStaffMember": false,
    "isDeveloper": false,
    "staffMemberTitle": '',
    "showEmail": false,
    "isHideOnConnect": false,
    "contractStartDate": null,
    "receivesReceipts": false,
};

/** A fresh, independent copy of the blank member form. */
export function newUserState() {
    // Every value in the template is JSON-safe (strings, booleans, numbers,
    // arrays, plain objects, null) — deliberately no Date or Timestamp — so this
    // is a safe deep copy and works on every browser the portal supports.
    return JSON.parse(JSON.stringify(INITIAL_USER_TEMPLATE));
}

// Kept for existing importers. Treat it as read-only shape documentation; for
// anything that touches a form, call newUserState().
export const InitialUserState = INITIAL_USER_TEMPLATE;

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        // Use 2px gap below the label (per the design system)
        ...shorthands.gap("2px")
    },
    control: {
        maxWidth: "300px",
    },
});

// const membershipsoptions = [
//     { "id": "Lift", "name": "Lift" },
//     { "id": "Ground", "name": "Ground" },
//     { "id": "Premium", "name": "Premium" }
// ]

const genderoptions = [
    { "id": "Male", "name": "Male" },
    { "id": "Female", "name": "Female" },
    { "id": "prefer_not_to_say", "name": "prefer not to say" }
]

const memberAccessPermission = [
    { "id": "Admin", "name": "Admin" },
    { "id": "Community", "name": "Community" },
    { "id": "Reservations", "name": "Reservations" },
    { "id": "Locations", "name": "Locations" },
    { "id": "People", "name": "People" },
    { "id": "AppSetting", "name": "AppSetting" },
    { "id": "POS", "name": "POS" }
]

function UserForm(props) {
    const styles = useStyles();
    const { handleSubmit, control, reset, setValue, formState: { isDirty, dirtyFields } } = useForm({
        defaultValues: props.selectedUser && typeof (props.selectedUser) == "object" ? props.selectedUser : newUserState()
    });
    const [password, setPassword] = useState("");
    const [profilePic, setProfilePic] = useState(null);
    const [fileMainImage, setFileMainImage] = useState("");
    const [percent, setPercent] = useState(0);
    const [insuranceImage, setInsuranceImage] = useState(null);
    const [insuranceUploadImage, setInsuranceUploadImage] = useState(null);
    const [dlImage, setDlImage] = useState(null);
    const [dlUploadImage, setUploadDlImage] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fileType, setFileType] = useState('');
    const [linkUserPlaceholder, setLinkUserPlaceholder] = useState('');
    const [matchingOptions, setMatchingOptions] = useState([]);
    const [isAccountHolder, setIsAccountHolder] = useState(false);
    const [parentAccountUser, setParentAccountUser] = useState(null);
    const [hasBankAndCard, setHasBankAndCard] = useState(false);
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [subscriptionAddOnsList, setSubscriptionAddOnsList] = useState([]);
    const [user, loading, error] = useAuthState(auth);
    const [selectedMembershipPlaceholder, setSeletedMembershipPlaceholder] = useState("");
    const [selectedGenderPlaceholder, setSelectedGenderPlaceholder] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(true);
    const [isEditPasswordDialogOpen, setIsEditPasswordDialogOpen] = useState(false);
    const [isUpdateEmailDialogOpen, setIsUpdateEmailDialogOpen] = useState(false);
    const [userid, setUserid] = useState('');

    // Membership lifecycle. Deliberately NOT a react-hook-form field: a status
    // change has to go through POST /setMembershipStatus, which writes the status
    // and the member-number tenure in one transaction. Saving it with the rest of
    // the form would set the status without closing or opening the tenure, which
    // is the whole mechanism that stops a reissued number inheriting the previous
    // holder's spend. So it applies immediately and says so.
    const MEMBERSHIP_STATUS_OPTIONS = [
        { key: "active", text: "Active" },
        { key: "paused", text: "Paused" },
        { key: "archived", text: "Archived" },
    ];
    const [membershipStatus, setMembershipStatus] = useState("active");
    const [statusSaving, setStatusSaving] = useState(false);

    // Members created before the field existed have no value, and they are active.
    useEffect(() => {
        const existing = props.selectedUser && typeof (props.selectedUser) == "object"
            ? (props.selectedUser.membershipStatus || "active")
            : "active";
        setMembershipStatus(existing);
    }, [props.selectedUser]);

    async function applyMembershipStatus(next) {
        const memberId = props.selectedUser && props.selectedUser.id;
        if (!memberId || next === membershipStatus) return;
        const previous = membershipStatus;
        setStatusSaving(true);
        setMembershipStatus(next);
        try {
            const token = await auth.currentUser?.getIdToken();
            await axios.post(
                `${Base_Url}/api/setMembershipStatus`,
                { userId: memberId, status: next, reason: "set from the member form" },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            props.updateGrid();
        } catch (error) {
            // Put the control back where it was: the change did not happen.
            setMembershipStatus(previous);
            const res = error.response;
            const msg =
                (res && res.data && res.data.error && res.data.error.message) ||
                error.message || "Could not change status";
            // A 409 means another member still holds this member number. The server
            // names them and says what to do, so show that rather than a generic error.
            notify(msg, "error");
            trackException(JSON.stringify(error));
        } finally {
            setStatusSaving(false);
        }
    }


    useEffect(() => {
    if (props.selectedUser) {
        setUserid(props?.selectedUser?.id);
    }
    }, [props.selectedUser]);

    const { fields, append, remove, replace } = useFieldArray({
        name: "phoneNumbers",
        control
    });
    useEffect(() => {
        console.log("Fields Updated:", fields);
    }, [fields]);

    async function getStripeCustomerIds(email) 
    {

    let config = {
        method: 'get',
        url: `${Base_Url}/stripeApi/searchStripeUserByEmail?email=${email}`,
        headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
    };
    try {
        const response = await axios.request(config);
        if (response && response.data && (response?.data?.customers?.data ?? []).length > 0) {
            let customer = response.data.customers.data[0];
            return customer.id; // Stripe customer ID
        }
        else {
            return '';
        }
    } catch (error) {
        return '';
    }
    
    }




    const getStripeSubscriptionList = async () => {
        let config = {
            method: "get",
            url: `${Base_Url}/stripeApi/getSubscriptionProducts`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.accessToken}`,
            },
        };
        axios
            .request(config)
            .then((response) => {
                if (response && response.data && response.data.data) {
                    // console.log(response.data);
                    //  setReaderList(response.data.data.data);
                    setSubscriptionList(response?.data?.data?.filter((data) => data?.metadata?.SubCategory !== "Addon"));
                    setSubscriptionAddOnsList(response?.data?.data?.filter((data) => data?.metadata?.SubCategory === "Addon"));

                }
            })
            .catch((error) => {
                console.log(error);
                trackException(JSON.stringify(error))
            });
    };

    function removeUndefined(obj) {
        return Object.fromEntries(
            Object.entries(obj).filter(([_, v]) => v !== undefined)
        );
    }




    const onSubmit = async formdata => {


        console.log("Form Data Submitted:", formdata);

        var data = formdata;

        // A staff account with no accessPermission can sign in but cannot reach any
        // part of the portal - the login lands nowhere, which reads to the user as a
        // broken password. isAdmin does NOT substitute for it: the portal gates on
        // accessPermission, and several accounts carry isAdmin with deliberately
        // narrower permissions, so the two are not interchangeable. Warn before
        // saving rather than letting the account quietly become unusable.
        if (
            (data.isStaffMember === true || data.isAdmin === true) &&
            (!data.accessPermission || data.accessPermission.length === 0)
        ) {
            const proceed = window.confirm(
                "This account has no portal permissions assigned, so the user will be able to sign in but will not be able to open any page in the portal.\n\nSet a permission under Access Permission, or press OK to save anyway."
            );
            if (!proceed) {
                return;
            }
        }
        debugger;
        if (data.email) {
            data.stripeCustomerId = await getStripeCustomerIds(data?.email);
        }
        console.log("Stripe Customer ID:", data.stripeCustomerId);
        // const stripeCustomerId = props?.selectedUser?.stripeCustomerId
        // if(!data.id)
        // {
        //     data.stripeCustomerId = ''; 
        // }

        /**As Discuss we will upload it later */
        // if (data && Array.isArray(data?.memberships) && data?.memberships.length > 0 && stripeCustomerId) {
        //     let filterIdsList = data?.memberships?.filter(value => !props?.selectedUser?.memberships?.includes(value));

        //     filterIdsList?.forEach((id) => {
        //         createCustomerSubscriptionPOSTRequest(id, stripeCustomerId)
        //     })
        // }

        data.email = data.email.toLowerCase()
        if (data.yearlyRequiredSpend && parseFloat(data.yearlyRequiredSpend) > 0) {
            data.yearlyRequiredSpend = parseFloat(data.yearlyRequiredSpend);
        } else {
            data.yearlyRequiredSpend = 2000;
        }
        var id = "";
        setShowLoader(true)
        if (props.selectedUser && typeof (props.selectedUser) == "object" && props.selectedUser.id && props.selectedUser.id != "") {
            id = props.selectedUser.id;
            data.lastBillingCalculationDate = props.selectedUser.lastBillingCalculationDate || Timestamp.now();
            data.createdAt = props.selectedUser.createdAt || Timestamp.now();
            const sanitizedData = removeUndefined(data);
            await UserDataService.updateUser(props.selectedUser.id, sanitizedData);
            removePreviouseUserAccountHolder(sanitizedData)
            uploadImagesAndUpdate(sanitizedData)
        } else {
            data.id = "";

            // Step 1: create (or, for an orphaned account, resolve) the Auth user.
            let addeduser;
            try {
                addeduser = await apiRegisterWithEmailAndPassword2(data.email, password)
            } catch (error) {
                if (error.code === 'auth/email-already-in-use' || error.code == 'auth/email-already-exists') {
                    alert("A user with this email already exists and could not be loaded. Please try again.")
                } else {
                    alert(error?.message || "Failed to create user.")
                }
                setShowLoader(false)
                return
            }

            data.id = addeduser.uid;

            // Step 2: if the Auth account already existed, only proceed when it is
            // an *orphan* (no Firestore member doc). Never overwrite an active member.
            if (addeduser._existed) {
                const userInfo = await UserDataService.getUserByEmail(data.email);
                if (userInfo.docs.length > 0) {
                    // Archiving no longer deletes the member, so the most common
                    // reason to land here is an archived member being re-added by
                    // hand. "A member with this email already exists" is true but
                    // useless — it does not say that the member is sitting in the
                    // grid, archived, one status change away from being back.
                    const existingStatus = (userInfo.docs[0].data() || {}).membershipStatus || "active";
                    // "error" here is not editorial: the add was refused. It also
                    // buys 8s on screen instead of 4s, which this instruction needs.
                    notify(
                        existingStatus === "archived"
                            ? "They are still in the member list. Set their Membership Status to Active to restore the member, their number and their app login. Adding them again would create a duplicate."
                            : "A member with this email already exists.",
                        "error",
                        existingStatus === "archived" ? "This member is archived, not missing" : undefined
                    )
                    setShowLoader(false)
                    return
                }
                // Recover: if the email belongs to an existing service provider,
                // keep their id; otherwise create the member doc against the Auth uid.
                const userInfoProvider = await ServiceProviderDataService.getServiceProviderByEmail(data.email);
                if (userInfoProvider.docs.length > 0) {
                    data.id = userInfoProvider.docs[0].data().id
                }
            }

            data.lastBillingCalculationDate = Timestamp.now();
            data.createdAt = Timestamp.now();

            // Step 3: write the member doc. If this fails after we just created the
            // Auth user, roll the Auth user back so it doesn't become an orphan.
            try {
                await UserDataService.addUser(data, data.id);
            } catch (writeErr) {
                if (!addeduser._existed) {
                    await apiDeleteUserAuth(data.id)
                }
                trackException(JSON.stringify(writeErr))
                alert("Failed to save member: " + (writeErr?.message || writeErr))
                setShowLoader(false)
                return
            }

            // An existing Auth account that is DISABLED belongs to someone who was
            // archived. The member doc has just been written and reads as active,
            // but the Auth account is still disabled, so they cannot sign in — and
            // nothing on this screen would have said so.
            //
            // Deliberately not fixed here by re-enabling the account: /createNewUser
            // has no authentication at all, so anything that re-enables a disabled
            // account from that path would let anyone restore an archived member's
            // access with an email and a password. The Membership Status control is
            // the one sanctioned route, and it does the work in a transaction.
            if (addeduser._existed && addeduser.disabled === true) {
                notify(
                    "Set their Membership Status to Active to switch it back on.",
                    "warning",
                    "Member added, but their app login is still disabled"
                )
            }

            uploadImagesAndUpdate(data)
            addUserAccountHolder(data)
        }
    }

    function resetAndClose() {
        setShowLoader(false)
        // reset() with no argument restores react-hook-form's defaultValues — which
        // is the object this form was constructed with. Passing a fresh blank makes
        // that explicit and means a mutated default can never be restored.
        reset(newUserState())
        // And clear the field array by hand: useFieldArray keeps its own row list
        // which reset() does not reliably re-sync. This is the path that was still
        // broken after the first fix — that one only cleared the array when the
        // effect re-ran, so adding one new member straight after another kept the
        // previous member's phone number on screen.
        replace([{ isPrimary: false, number: "", type: "" }])
        setPassword("")
        props.setIsOpen(false);
        props.updateGrid();
    }
    async function removePreviouseUserAccountHolder(data) {
        if (props.selectedUser.linkedUserIds && isAccountHolder) {
            const linkedUserIds = props.selectedUser.linkedUserIds;
            // Use map to create an array of promises
            const updatePromises = linkedUserIds.map(async relativeUserId => {
                await UserDataService.updateUserField(relativeUserId, { accountHolderId: "", linkedUserIds: [], memberNumber: "" });
            });
            // Use Promise.all to wait for all promises to resolve
            await Promise.all(updatePromises);
            addUserAccountHolder(data)
        }
    }
    async function addUserAccountHolder(data) {
        if (data.linkedUserIds && isAccountHolder) {
            const linkedUserIds = data.linkedUserIds;
             // Use map to create an array of promises
            let parentMemberNumber = data.memberNumber
            const updatePromises = linkedUserIds.map(async (relativeUserId) => {
                try {
                    // A relative links to the holder + the other relatives, never to
                    // itself. Copying data.linkedUserIds verbatim wrongly included the
                    // relative's own id, which broke the cross-account fan-out.
                    const relativeLinkedIds = [data.id, ...data.linkedUserIds.filter(id => id !== relativeUserId)];
                    await UserDataService.updateUserField(relativeUserId, {
                        accountHolderId: data.id,
                        linkedUserIds: relativeLinkedIds,
                        memberNumber: parentMemberNumber
                    });
                } catch (error) {
                    // Optionally log to external service here
                }
            });
            // Use Promise.all to wait for all promises to resolve
            await Promise.all(updatePromises);
        }
    }

    async function uploadImagesAndUpdate(data) {
        try {
            const dataObj = data;
            let profilePicUrl = ''
            let dlImageUrl = ''
            let insuranceImageUrl = ''
            if (profilePic && fileMainImage) {
                profilePicUrl = await uploadImage2(data, 'ProfilePic', fileMainImage);
                dataObj.profilePic = profilePicUrl;
            } else {
                if (profilePic && profilePic != "") { } else {
                    dataObj.profilePic = "";
                }
            }
            if (dlUploadImage && dlUploadImage != "") {
                dlImageUrl = await uploadImage2(data, 'Drivinglicence', dlUploadImage);
                dataObj.dlImage = dlImageUrl;
            } else {
                if (dlImage && dlImage != "") { } else {
                    dataObj.dlImage = "";
                }
            }
            if (insuranceUploadImage && insuranceUploadImage != "") {
                insuranceImageUrl = await uploadImage2(data, 'InsuranceDoc', insuranceUploadImage);
                dataObj.insuranceImage = insuranceImageUrl;
            } else {
                if (insuranceImage && insuranceImage != "") { } else {
                    dataObj.insuranceImage = "";
                }
            }
            //console.log("dataObj=>", dataObj)
            // Update the user in the database with the updated URLs
            await UserDataService.updateUser(data.id, dataObj);
            resetAndClose()
        } catch (error) {
            console.error('Error uploading images and updating user:', error);
            resetAndClose()
        }
    }

    async function uploadImage2(data, folder, image) {
        if (image && image !== "") {
            const storageRef = ref(storage, `/${folder}/${data.id}.png`);
            const uploadTask = uploadBytesResumable(storageRef, image);
            return new Promise(async (resolve, reject) => {
                uploadTask.on(
                    "state_changed",
                    (snapshot) => {
                        const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        setPercent(percent);
                    },
                    reject, // Reject on error
                    async () => {
                        try {
                            // Resolve with the download URL
                            const url = await getDownloadURL(uploadTask.snapshot.ref);
                            //data[`${folder.toLowerCase()}Image`] = url;
                            resolve(url);
                        } catch (error) {
                            reject(error);
                        }
                    }
                );
            });
        } else {
            // Return a resolved promise if no image is provided
            return Promise.resolve();
        }
    }

    const handleChangeMainImage = (event) => {
        setProfilePic(URL.createObjectURL(event.target.files[0]));
        setFileMainImage(event.target.files[0]);
    }
    const handleChangeDLImage = (event) => {
        setDlImage(URL.createObjectURL(event.target.files[0]));
        setUploadDlImage(event.target.files[0]);
    }
    const handleChangeInsImage = (event) => {
        setInsuranceImage(URL.createObjectURL(event.target.files[0]));
        setInsuranceUploadImage(event.target.files[0]);
    }

    const removeMainImage = () => {
        setProfilePic("");
        setFileMainImage("");
    }

    const removeDlImage = () => {
        setDlImage("")
        setUploadDlImage("")
    }
    const removeInsImage = () => {
        setInsuranceImage("")
        setInsuranceUploadImage("")
    }

    async function getUserDetails() {
        if (props.selectedUser && typeof (props.selectedUser) == "object" && props.selectedUser.id) {
            setIsLoading(true)
            try {
                const userDoc = await UserDataService.getUser(props.selectedUser.id);
                let userDocObj = userDoc.data();
                if (userDocObj) {
                    if (userDocObj.profilePic) {
                        setProfilePic(userDocObj.profilePic)
                    } else {
                        setProfilePic(null)
                    }
                    if (userDocObj.insuranceImage) {
                        setInsuranceImage(userDocObj.insuranceImage)
                    } else {
                        setInsuranceImage(null)
                    }
                    if (userDocObj.dlImage) {
                        setDlImage(userDocObj.dlImage)
                    } else {
                        setDlImage(null)
                    }

                    if (userDocObj.insuranceInfo) {
                        let insuranceI = userDocObj.insuranceInfo
                        setValue('insuranceInfo.policyHolderName', insuranceI['policyHolderName']);
                        setValue('insuranceInfo.insuranceCompany', insuranceI['insuranceCompany']);
                        setValue('insuranceInfo.policyNumber', insuranceI['policyNumber']);
                        setValue('insuranceInfo.state', insuranceI['state']);
                    }
                }
                setIsLoading(false)
            } catch (error) {
                alert(error)
                setIsLoading(false)
            }
        }
    }

    async function getStripCustomerId() {
        if (props.selectedUser && props.selectedUser.email) {
            let config = {
                method: 'get',
                url: `${Base_Url}/stripeApi/searchStripeUserByEmail?email=${props.selectedUser.email}`,
                headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.accessToken}`,
            },
            };
            axios.request(config)
                .then((response) => {


                    if (response && response.data && (response?.data?.customers?.data ?? []).length > 0) {
                        let customer = response.data.customers.data[0];

                        getPaymentMethodByCustomerId(customer.id)
                    } else {
                    }
                })
                .catch((error) => { });
        }
    }

    async function getPaymentMethodByCustomerId(stripeCustomerId) {
        if (props.selectedUser) {
            let config = {
                method: 'get',
                url: `${Base_Url}/stripeApi/getListPaymentMethods?customerId=${stripeCustomerId}`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${user.accessToken}`,
                }
            };
            axios.request(config)
                .then((response) => {
                    if (response && response.data) {
                        const resArr = response.data.data
                        let hasBankAccount = false;
                        let hasCard = false;
                        let bankList = resArr.filter(data => data.type === "bank_account").map(data => ({
                            id: data.id,
                        }));
                        let bankList2 = resArr.filter(data => data.type === "us_bank_account").map(data => ({
                            id: data.id,
                        }));
                        let finalBankList = [...bankList, ...bankList2];
                        let cardList = resArr.filter(data => data.type == "card");
                        if (finalBankList && finalBankList.length > 0) {
                            hasBankAccount = true
                        }
                        if (cardList && cardList.length > 0) {
                            hasCard = true
                        }
                        if (hasBankAccount || hasCard) {
                            setHasBankAndCard(true)
                        }
                    }
                })
                .catch((error) => {
                });
        }
    }

    const checkHasStripeAccount = () => {
        if (props.selectedUser && typeof (props.selectedUser) == "object" && props.selectedUser.stripeCustomerId && props.selectedUser.stripeCustomerId != undefined && props.selectedUser.stripeCustomerId != "") {
            return true
        } else {
            return false
        }
    }


    useEffect(() => {
        if (insuranceImage && insuranceImage != "") {
            const getFileType = async () => {
                let data = JSON.stringify({
                    "imageUrl": insuranceImage
                });
                let config = {
                    method: 'post',
                    url: `${Base_Url}/api/imageContent`,
                    headers: {
                        'Content-Type': 'application/json',
                        // Sent now that /imageContent is admin-gated; it was open
                        // to the internet and fetches arbitrary image URLs.
                        Authorization: `Bearer ${await getAuthToken()}`
                    },
                    data: data
                };
                axios.request(config)
                    .then((response) => {
                        if (response.data && response.data && response.data.data != "") {
                            setFileType(response.data.data)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            };
            getFileType();
        }
    }, [insuranceImage]);


    useEffect(() => {
        setProfilePic(null);
        setUploadDlImage("");
        setInsuranceUploadImage("");
        setInsuranceImage(null);
        setDlImage(null);
        setSubscriptionList([]);
        getStripeSubscriptionList();
        // A fresh blank every time this effect runs. Reading fallbacks out of the
        // shared template is what let one member's values leak into the next form.
        const blank = newUserState();
        const formfields = ['email', 'firstName', 'lastName', 'groupIds',
            'isAdmin', 'isHonorary', 'memberNumber', 'memberships', 'genderValue', 'phoneNumbers', 'id', 'insuranceImage', 'dlImage', 'dLNumber', 'linkedUserIds', 'accountHolderId', 'accessPermission', 'yearlyRequiredSpend', 'isStaffMember', 'isDeveloper', 'staffMemberTitle', 'showEmail', 'isHideOnConnect', 'contractStartDate', 'receivesReceipts'];
        if (props.selectedUser && typeof (props.selectedUser) == "object") {
            formfields.forEach(field => setValue(field, props.selectedUser[field] ? props.selectedUser[field] : blank[field]));
            let contractDate = null;
            if (props.selectedUser.contractStartDate) {
                const rawDate = props.selectedUser.contractStartDate;
                const dateObj = (rawDate && typeof rawDate.toDate === "function")
                    ? rawDate.toDate()
                    : new Date(rawDate);
                contractDate = !isNaN(dateObj.getTime()) ? dateObj : null;
                console.log("Contract Start Date - Converted:", contractDate);
            }

            formfields.forEach(field => {
                if (field === 'contractStartDate') {
                    setValue(field, contractDate);
                } else {
                    setValue(field, props.selectedUser[field] ? props.selectedUser[field] : blank[field]);
                }
            });
            setValue('addOn', []);
            setValue('address.city', props.selectedUser.address?.city);
            setValue('address.country', props.selectedUser.address?.country);
            setValue('address.state', props.selectedUser.address?.state);
            setValue('address.street1', props.selectedUser.address?.street1);
            setValue('address.street2', props.selectedUser.address?.street2);
            setValue('address.zip', props.selectedUser.address?.zip);
            setProfilePic(props.selectedUser.profilePic);
            setHasBankAndCard(false)
            getUserDetails();
            reset({
                ...props.selectedUser,
                contractStartDate: contractDate,
                phoneNumbers: props.selectedUser.phoneNumbers?.length > 0
                    ? props.selectedUser.phoneNumbers
                    : [{ isPrimary: false, number: "", type: "" }]
            });
            setValue("contractStartDate", contractDate);
            setValue("phoneNumbers", props.selectedUser.phoneNumbers || [{ isPrimary: false, number: "", type: "" }]);

            //TODO: Get all list linkedUserIds from allusers, then filterd this all users
            const filteredUserData = filterData(props.allusers, props.selectedUser?.linkedUserIds);
            setMatchingOptions([...filteredUserData])

            const filteredAllurer = props.allusers.filter(person => props.selectedUser?.linkedUserIds?.includes(person.id));
            if (filteredAllurer && filteredAllurer.length > 0) {
                const resultstr = filteredAllurer.map(person => ` ${person.firstName} ${person.lastName} `);
                setLinkUserPlaceholder(resultstr)
            } else {
                setLinkUserPlaceholder('')
            }
            if (props.selectedUser.accountHolderId && props.selectedUser.accountHolderId != "" && props.selectedUser.accountHolderId != props.selectedUser.id) {
                setIsAccountHolder(false)
            } else {
                setIsAccountHolder(true)
            }
            if (props.selectedUser.accountHolderId) {
                let parentAc = props.allusers.filter(obj => obj.id == props.selectedUser.accountHolderId);
                if (parentAc && parentAc.length > 0) {
                    setParentAccountUser(parentAc[0])
                } else {
                    setParentAccountUser(null)
                }
            } else {
                setParentAccountUser(null)
            }
            getStripCustomerId()

            if (
                props.selectedUser.memberships &&
                props.selectedUser.memberships.length > 0
            ) {
                let filteredSubscrption = subscriptionList
                    .filter(data => props.selectedUser.memberships.includes(data.id))
                    .map(data => data.description);
                setSeletedMembershipPlaceholder(filteredSubscrption.join(', '));
            } else {
                setSeletedMembershipPlaceholder("");
            }

            if (
                props.selectedUser.genderValue
            ) {
                setSelectedGenderPlaceholder(props.selectedUser.genderValue);
            } else {
                setSelectedGenderPlaceholder("");
            }

            if (props.selectedUser.staffMemberTitle) { }
            else { setValue('staffMemberTitle', ''); }

        } else {
            formfields.forEach(field => setValue(field, blank[field]));
            // phoneNumbers is a useFieldArray, which keeps its own internal list of
            // rows. setValue on the array name does NOT re-sync that list, so the
            // rows rendered for the previously opened member survived into the blank
            // "add member" form - and staff saved new members carrying the previous
            // member's phone number. The edit branch above avoids this only because
            // it happens to call reset(). Clear the array explicitly.
            replace([{ isPrimary: false, number: "", type: "" }]);
            setValue('addOn', []);
            setValue('address.city', blank.address['city']);
            setValue('address.country', blank.address['country']);
            setValue('address.state', blank.address['state']);
            setValue('address.street1', blank.address['street1']);
            setValue('address.street2', blank.address['street2']);
            setValue('address.zip', blank.address['zip']);
            setInsuranceImage(null)
            setDlImage(null)
            setSeletedMembershipPlaceholder("");
            setSelectedGenderPlaceholder("");
            setValue('insuranceInfo.policyHolderName', '');
            setValue('insuranceInfo.insuranceCompany', '');
            setValue('insuranceInfo.policyNumber', '');
            setValue('insuranceInfo.state', '');
            setLinkUserPlaceholder('');
            setIsAccountHolder(true)
            setParentAccountUser(null)
            setHasBankAndCard(false)
        }
    }, [props.selectedUser])

    function setConnectedAccountStr(data) {
        const filteredAllurer = props.allusers.filter(person => data.selectedOptions.includes(person.id));
        if (filteredAllurer && filteredAllurer.length > 0) {
            const resultstr = filteredAllurer.map(person => ` ${person.firstName} ${person.lastName}`);
            setLinkUserPlaceholder(resultstr)
        } else {
            setLinkUserPlaceholder('')
        }
    }

    function handlePasswordReset() {
        setIsEditPasswordDialogOpen(true);
        setPassword("");
    }

    async function handleReset() {

        try {
              const token = await user.getIdToken();
        
              const response = await fetch(`https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=${process.env.REACT_APP_FIREBASE_API_KEY}`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                //   Authorization: `Bearer ${token}`,
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  email: props.selectedUser.email,
                  requestType: 'PASSWORD_RESET',
                }),
              });
        
              if (!response.ok) {
                const errText = await response.text().catch(() => "");
                console.error("API error:", response.status, errText);
                return;
              }

              alert("Password reset email sent successfully.");
        
              const data = await response.json().catch(() => null);
              console.log("API Response:", data);
            } catch (error) {
              console.error("Error updating password:", error);
            } finally {
            }
        
    }

    const onChange = (event) => {
    const value = event.target.value.trim().toLowerCase();
    const filteredUserData = filterData(props.allusers, props.selectedUser?.linkedUserIds);

    const matches = filteredUserData.filter(
        (option) =>
            option.firstName.toLowerCase().startsWith(value) ||
            option.lastName.toLowerCase().startsWith(value)
    );

    setMatchingOptions(matches);
};


    return (
        <DrawerOverlay
            size={"medium"}
            position={"right"}
            open={props.isOpen}
            style={{ width: "504px" }}
            onOpenChange={(_, { open }) => props.setIsOpen(open)}
        ><DrawerHeader style={{
            background: "#F7F7F7",
            padding: "26px 32px"
        }}>
                <DrawerHeaderTitle

                    action={
                        <Button
                            appearance="subtle"
                            aria-label="Close"
                            icon={<Dismiss24Regular />}
                            onClick={() => props.setIsOpen(false)}
                        />
                    }
                >
                    <div className={"vertical-center"}
                        style={{ display: "flex", alignItems: "center", height: "100%", paddingLeft: "6px" }}>
                        <div><UserFormAddSVG /></div>
                        <span
                            className={"user-form__header "}>{props.selectedUser && typeof (props.selectedUser) == "object" ? "Edit" : "New"} User</span>
                    </div>

                    {
                        isLoading ? <Spinner label="Loading..." /> : <div />
                    }
                </DrawerHeaderTitle>
            </DrawerHeader>

            <DrawerBody>
                <form onSubmit={handleSubmit(onSubmit)}
                  
                // {isEditPasswordDialogOpen && (
                //     <EditPasswordDialogBox
                //         isOpen={isEditPasswordDialogOpen}
                //         setIsOpen={setIsEditPasswordDialogOpen}
                //         userEmail={props.selectedUser.email}
                //     />
                // )}
                    className={styles.root} onReset={reset}
                    id={props.selectedUser && typeof (props.selectedUser) == "object" ? props.selectedUser.id : "New"}>
                    
                    {
                        props.selectedUser && typeof (props.selectedUser) == "object" && props.selectedUser.totalPoint && (
                            <Label className={"side-drawer-field__label"} style={{ marginTop: 32 }}>
                                <div className={"d-flex justify-space-between"}>
                                    <div>Points balance:</div>
                                    <div style={{
                                        color: '#000',
                                        fontFamily: 'Nunito Sans',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: '28px' // You can specify this directly as a string
                                    }}>{props.selectedUser.totalPoint.toFixed(2)}</div>
                                </div>
                            </Label>
                        )
                    }

                    <Label className={"side-drawer-field__label"} style={{ marginTop: "12px" }}>Email*</Label>
                    <Controller
                        name="email"
                        key="email"

                        control={control}
                        rules={{ required: true }}

                        render={({ field }) => (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <input
                                    placeholder={"Enter Email"}
                                    style={{ flex: 1 }}
                                    className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"} {...field}
                                    disabled={(props.selectedUser && typeof (props.selectedUser) == "object") ? true : false} />
                            </div>
                        )}
                    />

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "16px",
                            marginBottom: "16px",
                        }}
                    >
                        {props.selectedUser && typeof (props.selectedUser) == "object" && (
                            <Button
                                appearance="secondary"
                                size="small"
                                style={{
                                    backgroundColor: "#cd4806e8",
                                    color: "white",
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    border: "none",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                }}
                                onClick={() => setIsUpdateEmailDialogOpen(true)}
                            >
                                Update Email
                            </Button>
                        )}
                    </div>

                    <Label className={"side-drawer-field__label"}>Password*</Label>
                    <Input placeholder={"Enter Password"} contentAfter={<span className={"pointer"} onClick={() => {
                        setPasswordVisible((prevState) => (!prevState))
                    }}> {passwordVisible ? <EyeViewSVG aria-label="Enter by voice" /> : <EyeViewDisableSVG />}</span>}
                        className={"side-drawer-field-date  side-drawer-field__gap side-drawer-field__gap"}
                        value={password} onChange={(ev) => setPassword(ev.target.value)}    
                        disabled={(props.selectedUser && typeof (props.selectedUser) == "object") ? true : false}
                        type={passwordVisible ? "password" : "text"} />

                   <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "16px",
                            marginTop: "16px",
                        }}
                        >
                        <Button
                            type="button"
                            onClick={handlePasswordReset}
                            style={{
                            backgroundColor: "#cd4806e8", // blue-600
                            color: "white",
                            padding: "8px 16px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#1d4ed8")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#2563eb")}
                        >
                            Edit Password
                        </Button>
                            <div>OR</div>
                        <Button
                            type="button"
                            onClick={handleReset}
                            style={{
                            backgroundColor: "#e5e7eb", // gray-200
                            color: "black",
                            padding: "8px 16px",
                            borderRadius: "6px",
                            border: "none",
                            cursor: "pointer",
                            transition: "all 0.2s ease-in-out",
                            }}
                            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#d1d5db")}
                            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#e5e7eb")}
                        >
                           Send Reset Password Link
                        </Button>
                        </div>


                    <Label className={"side-drawer-field__label"} style={{ marginTop: "8px" }}>
                        First Name*
                    </Label>
                    <Controller
                        name="firstName"

                        key="firstName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => <input
                            placeholder={"Enter First Name"}
                            className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"} {...field} />}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Last Name*
                    </Label>
                    <Controller
                        name="lastName"
                        key="lastName"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => <input
                            className={"side-drawer-field  side-drawer-field__gap"} {...field}
                            placeholder={"Enter Last Name"} />}
                    />
                    <Label className={"side-drawer-field__label"} style={{ marginTop: "8px" }}>
                        Required Total Annual Spend
                    </Label>
                    <Controller
                        name="yearlyRequiredSpend"
                        key="yearlyRequiredSpend"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => <input
                            placeholder={"Required Annual Total Spend"}
                            className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"} {...field} />}
                    />

                    {/* Only for members that exist. A new member has no record to set a
                        status on yet, and starts active. */}
                    {props.selectedUser && typeof (props.selectedUser) == "object" ? (
                        <>
                            <Label className={"side-drawer-field__label"} style={{ marginTop: "8px" }}>
                                Membership Status
                            </Label>
                            <Dropdown
                                className={"side-drawer-field__gap"}
                                style={{ width: "100%" }}
                                disabled={statusSaving}
                                selectedOptions={[membershipStatus]}
                                value={
                                    (MEMBERSHIP_STATUS_OPTIONS.find(o => o.key === membershipStatus) || {}).text || "Active"
                                }
                                onOptionSelect={(e, d) => applyMembershipStatus(d.optionValue)}
                            >
                                {MEMBERSHIP_STATUS_OPTIONS.map(o => (
                                    <Option key={o.key} value={o.key}>{o.text}</Option>
                                ))}
                            </Dropdown>
                            {/* Said plainly, because every other field on this form saves on
                                Submit and this one does not. */}
                            <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                                {statusSaving
                                    ? "Saving…"
                                    : membershipStatus === "archived"
                                        ? "Archived. The member number is released and can be given to a new member. Saved immediately — no need to submit."
                                        : membershipStatus === "paused"
                                            ? "Paused keeps the member and their number. Billing is unchanged. Saved immediately — no need to submit."
                                            : "Saved immediately — this one does not wait for Submit."}
                            </div>
                        </>
                    ) : null}

                    <Label className={"side-drawer-field__label"} style={{ marginTop: "8px" }}>
                        Admin
                    </Label>
                    <Controller
                        name="isAdmin"
                        key="isAdmin"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Honorary Member
                    </Label>
                    <Controller
                        name="isHonorary"
                        key="isHonorary"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Show Email
                    </Label>
                    <Controller
                        name="showEmail"
                        key="showEmail"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Staff Member
                    </Label>
                    <Controller
                        name="isStaffMember"
                        key="isStaffMember"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />

                    <Label className={"side-drawer-field__label"} style={{ marginTop: "8px" }}>
                        Staff Member Title
                    </Label>
                    <Controller
                        name="staffMemberTitle"
                        key="staffMemberTitle"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter staff member title"}
                            className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                            maxLength={100}
                            {...field} />}
                    />

                    <Label className={"side-drawer-field__label"} style={{ marginTop: "8px" }}>
                        Contract Start Date
                    </Label>
                    <Controller
                        name="contractStartDate"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div className={"datepicker-custom-wrap"}>
                                <DatePicker
                                    {...field}
                                    showTimeSelect
                                    selected={field.value || null}
                                    onSelectDate={field.onChange}
                                    contentAfter={<DateSVG />}
                                    style={{
                                        width: "100%",
                                        height: "44px"
                                    }}
                                    placeholder="Contract Start Date"
                                    className={"side-drawer-field side-drawer-field__gap"}
                                    dateFormat={'do MMMM yyyy hh:mm a'}
                                />
                            </div>
                        )}
                    />

                    <Label className={"side-drawer-field__label"}>
                        Developer
                    </Label>
                    <Controller
                        name="isDeveloper"
                        key="isDeveloper"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Hide Connect
                    </Label>
                    <Controller
                        name="isHideOnConnect"
                        key="isHideOnConnect"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />
                    {/* Receipts for a linked member (spouse/child). The purchaser
                        always gets their own receipt; this adds a copy for this
                        member when someone else in their household buys. The
                        backend reads `receivesReceipts` when fanning out the
                        Klaviyo order receipt, so it applies to installed apps. */}
                    <Label className={"side-drawer-field__label"}>
                        Receives Receipts
                    </Label>
                    <Controller
                        name="receivesReceipts"
                        key="receivesReceipts"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <div onClick={() => field.onChange(!field.value)}>
                                <Switch checked={field.value} {...field} />
                            </div>
                        )}
                    />


                    <Divider className={"side-drawer-divider-gap"} />
                    {
                        isAccountHolder &&
                        <Label className={"side-drawer-section__typo"}
                            style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                            <ConnectAccountSVG /> <span style={{ marginLeft: "8px" }}>CONNECT ACCOUNT</span>
                        </Label>

                    }
                    {
                        isAccountHolder ?
                            hasBankAndCard ?
                                <Controller
                                    name="linkedUserIds"
                                    key="linkedUserIds"
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) =>
                                        <Combobox multiselect={true}
                                            className={"side-drawer-field-dropdown  side-drawer-field__gap"}
                                            //className={"side-drawer-field  side-drawer-field__gap"}
                                            //placeholder={linkUserPlaceholder}
                                            onChange={onChange}
                                            onOptionSelect={(ev, data) => {
                                                if (data.selectedOptions.length < 6) {
                                                    setConnectedAccountStr(data)
                                                    field.onChange(data.selectedOptions)
                                                }
                                            }}
                                            selectedOptions={field.value}
                                        >
                                            {matchingOptions.map((option) => (
                                                <Option key={option.id} value={option.id}>
                                                    {`${option.firstName} ${option.lastName}`}
                                                </Option>
                                            ))}
                                            {matchingOptions.length === 0 ? (
                                                <Option key="no-results" text="">
                                                    No results found
                                                </Option>
                                            ) : null}
                                        </Combobox>}
                                /> :
                                <Label className={"side-drawer-grey-help"} style={{ marginBottom: 24 }}>
                                    Primary account has no bank account and a credit card on file.
                                </Label> :
                            <div></div>
                    }
                    {
                        parentAccountUser && (
                            <Label>
                                Parent Account: {parentAccountUser.firstName} {parentAccountUser.lastName}
                            </Label>
                        )
                    }
                    <Label>
                        {linkUserPlaceholder && linkUserPlaceholder != "" ? `Connected Account:${linkUserPlaceholder}` : ''}
                    </Label>
                    <Label className={"side-drawer-field__label"}>
                        Member Number
                    </Label>
                    <Controller
                        name="memberNumber"
                        key="memberNumber"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            className={"side-drawer-field  side-drawer-field__gap"}
                            placeholder={"Enter Member Number"} {...field} />}
                    />

                    {/* <Label className={"side-drawer-field__label"}>
                        Access Permission
                    </Label>
                    <Controller
                        name="accessPermission"
                        key="accessPermission"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <Dropdown multiselect={true}
                            className={"side-drawer-field-default  side-drawer-field__gap"}
                            onOptionSelect={(ev, data) => field.onChange(data.selectedOptions)}
                            selectedOptions={field.value}>
                            {memberAccessPermission.map((option) => (
                                <Option key={option.id} value={option.id}>
                                    {option.name}
                                </Option>
                            ))}
                        </Dropdown>}
                    /> */}

                    <Label className={"side-drawer-field__label"}>
                        Gender
                    </Label>

                    <Controller
                        name="genderValue"
                        key="genderValue"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <Dropdown multiselect={false}
                            className={"side-drawer-field-dropdown  side-drawer-field__gap"}
                            onOptionSelect={(ev, data) => field.onChange(data.selectedOptions[0])}
                            placeholder={selectedGenderPlaceholder ? selectedGenderPlaceholder : "Select Gender"}
                            selectedOptions={[field.value]}>
                            {genderoptions.map((option) => (
                                <Option key={option.id} value={option.id}>
                                    {option.name}
                                </Option>
                            ))}
                        </Dropdown>}
                    />

                    <Divider className={"side-drawer-divider-gap"} />

                    <div className={"d-flex"} style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
                        <div><AddressSVG /></div>
                        <Label className={"side-drawer-section__typo"} style={{ marginLeft: "8px" }}>ADDRESS</Label>
                    </div>

                    <Label className={"side-drawer-field__label"}>
                        Street 1
                    </Label>
                    <Controller
                        name="address.street1"
                        key="address.street1"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter Street 1"}
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Street 2
                    </Label>
                    <Controller
                        name="address.street2"
                        key="address.street2"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter Street 2"}
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />

                    <div className={"d-flex justify-space-between"}>
                        <div style={{ display: "grid" }}>
                            <Label className={"side-drawer-field__label"}>City</Label>
                            <Controller
                                name="address.city"
                                key="address.city"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => <input
                                    placeholder={"Enter City"}
                                    className={"side-drawer-field side-drawer-field__gap"} {...field} />}
                            />
                        </div>
                        <div style={{ display: "grid" }}>
                            <Label className={"side-drawer-field__label"}>State</Label>
                            <Controller
                                name="address.state"
                                key="address.state"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => <input
                                    placeholder={"Enter State"}
                                    className={"side-drawer-field side-drawer-field__gap"} {...field} />}
                            />
                        </div>
                    </div>
                    <div className={"d-flex justify-space-between"}>
                        <div style={{ display: "grid" }}>
                            <Label className={"side-drawer-field__label"}>Country</Label>
                            <Controller
                                name="address.country"
                                key="address.country"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => <input
                                    placeholder={"Enter Country"}
                                    className={"side-drawer-field side-drawer-field__gap"} {...field} />}
                            />
                        </div>
                        <div style={{ display: "grid" }}>
                            <Label className={"side-drawer-field__label"}>Zip</Label>
                            <Controller
                                name="address.zip"
                                key="address.zip"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => <input
                                    placeholder={"Enter Zip"}
                                    className={"side-drawer-field side-drawer-field__gap"} {...field} />}
                            />
                        </div>
                    </div>

                    <Divider className={"side-drawer-divider-gap"} />
                    <Label className={"side-drawer-section__typo"} style={{ display: "flex", alignItems: "center" }}>
                        <PhoneSVG /> <span style={{ marginLeft: "8px" }}>Phone Numbers</span>
                    </Label>

                    {fields.map((obj, index) => {
                        return (
                            <>
                                <Label className={"side-drawer-field__label"} style={{ marginTop: "24px" }}>
                                    Number
                                </Label>
                                <Controller
                                    name={`phoneNumbers.${index}.number`}
                                    key={`phoneNumbers.${index}.number`}
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => <input
                                        placeholder={"Enter Nember"}
                                        className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                                />
                                <Label className={"side-drawer-field__label"}>
                                    Type
                                </Label>
                                <Controller
                                    name={`phoneNumbers.${index}.type`}
                                    key={`phoneNumbers.${index}.type`}
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => <input
                                        placeholder={"Enter Type"}
                                        className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                                />
                                <Label className={"side-drawer-field__label"}>
                                    Is Primary
                                </Label>
                                <Controller
                                    name={`phoneNumbers.${index}.isPrimary`}
                                    key={`phoneNumbers.${index}.isPrimary`}
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => (
                                        <div onClick={() => field.onChange(!field.value)}>
                                            <Switch checked={field.value} {...field} />
                                        </div>
                                    )} />
                                {fields.length > 1 && fields.length - 1 !== index && (
                                    <>
                                        <div className={"d-flex justify-end"}>

                                            <DeleteIcon onClick={() => remove(index)}>Remove</DeleteIcon>
                                        </div>
                                        <div>
                                            <Divider />
                                        </div>

                                    </>)}
                                {/*<Divider appearance="strong" className={"side-drawer-divider-gap"}></Divider>*/}
                            </>
                        )
                    })}
                    <div className={"sidebar-drawer-Addnew-lable"} onClick={() => append({ isPrimary: false, number: "", type: "" })} style={{ marginTop: "24px" }}>+ One More Number</div>

                    <Label> </Label>
                    <Divider className={"side-drawer-divider-gap"} />
                    <Label className={"side-drawer-section__typo"} style={{ display: "flex", alignItems: "center" }}>
                        <InsuranceSVG /> <span style={{ marginLeft: "8px" }}>INSURANCE</span>
                    </Label>

                    <Label className={"side-drawer-field__label"} style={{ marginTop: 27 }}>
                        Policy Holder Name
                    </Label>
                    <Controller
                        name="insuranceInfo.policyHolderName"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter Policy Holder Name"}
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Insurance Company
                    </Label>
                    <Controller
                        name="insuranceInfo.insuranceCompany"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter Insurance Company"}
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />
                    <Label className={"side-drawer-field__label"}>
                        Policy Number
                    </Label>
                    <Controller
                        name="insuranceInfo.policyNumber"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter Policy Number"}
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />
                    <Label className={"side-drawer-field__label"}>
                        State
                    </Label>
                    <Controller
                        name="insuranceInfo.state"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            placeholder={"Enter State"}
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />
                    <Label className={"side-drawer-field__label side-drawer-field__gap"}>Copy of Insurance</Label>
                    {!insuranceImage &&
                        <label className="sidebar-drawer-file-upload">
                            <input type="file" id="file1" onChange={handleChangeInsImage} accept="image/*"
                                className="   side-drawer-field__gap "
                                aria-label="File browser example" placeholder="Browse" />
                        </label>
                    }
                    {insuranceImage &&
                        <div>
                            {
                                fileType == "application/pdf" ?
                                    <div className={{ width: 100, height: 100 }}>
                                        <DocumentRegular style={{ width: 100, height: 100 }} />
                                    </div>
                                    :
                                    <Image width={130} height={100} src={insuranceImage} alt="ImageIns"></Image>
                            }
                            <Button icon={<DeleteIcon />} onClick={removeInsImage} />
                        </div>
                    }
                    {
                        insuranceImage && fileType && fileType == "application/pdf" ?
                            <a href={insuranceImage} target="_blank" rel="noopener noreferrer"><Label>Insurance
                                PDF</Label> </a> : <div />
                    }

                    <Divider className={"side-drawer-divider-gap"} />
                    <Label className={"side-drawer-section__typo"} style={{ display: "flex", alignItems: "center" }}>
                        <DrivingLicenceSVG /> <span style={{ marginLeft: "8px" }}> DRIVING LICENSE </span>
                    </Label>

                    <Label className={"side-drawer-field__label"} style={{ marginTop: "24px" }}>
                        Driving License #
                    </Label>
                    <Controller
                        name="dLNumber"
                        control={control}
                        rules={{ required: false }}
                        render={({ field }) => <input
                            className={"side-drawer-field  side-drawer-field__gap"} {...field} />}
                    />
                    <Label> </Label>
                    <div styles={{ marginTop: 20 }}></div>
                    <Label className={"side-drawer-field__label side-drawer-field__gap"}>Copy of Driving license</Label>
                    {!dlImage &&
                        <label className="sidebar-drawer-file-upload">
                            <input type="file" id="file1" onChange={handleChangeDLImage} accept="image/*"
                                className="side-drawer-field__gap"
                                aria-label="File browser example" placeholder="Browse" />
                        </label>
                    }
                    {dlImage && dlImage != "" &&
                        <div>
                            <Image width={130} height={100} src={dlImage} alt="ImageDl"></Image>
                            <Button icon={<DeleteIcon />} onClick={removeDlImage} />
                        </div>
                    }

                    <Divider style={{ marginTop: 24, marginBottom: 24 }} />

                    <Label className={"side-drawer-field__label side-drawer-field__gap"}>
                        Profile Picture
                    </Label>
                    {profilePic &&
                        <div>
                            <Image width={100} height={100} src={profilePic} alt="Main Image"></Image>
                            <Button icon={<DeleteIcon />} onClick={removeMainImage} />
                        </div>}
                    {!profilePic &&
                        <label className="sidebar-drawer-file-upload">
                            <input type="file" id="file1" onChange={handleChangeMainImage} accept="image/*"
                                className="side-drawer-field__gap" aria-label="File browser example" placeholder="Browse" />
                        </label>
                    }
                    {
                        showLoader ?
                            <Spinner label="Loading..." /> :
                            <div className="btnActions">
                                <button appearance="primary" type="submit" className="form-submit-btn"
                                >
                                    {props.selectedUser && typeof (props.selectedUser) == "object" ? 'Update' : 'Submit'}</button>
                                <button className="form-submit-cancel"
                                    onClick={() => props.setIsOpen(false)}>Cancel</button>
                            </div>
                    }
                </form>
            </DrawerBody>

            <EditPasswordDialogBox
                isDeleteDialogOpen={isEditPasswordDialogOpen}
                setIsOpen={(val) => {
                    setIsEditPasswordDialogOpen(val);
                }}
                text={"Password"}
                userid={userid}
            />
            <UpdateEmailDialogBox
                isOpen={isUpdateEmailDialogOpen}
                setIsOpen={setIsUpdateEmailDialogOpen}
                userId={userid}
                currentEmail={props.selectedUser?.email}
                onUpdateSuccess={() => {
                    props.updateGrid();
                    props.setIsOpen(false);
                }}
            />
        </DrawerOverlay>
    )   
}

export default UserForm

function filterData(data, selectedUserLinkedUserIds) {
    // Check if data or selectedUserLinkedUserIds is null or empty
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(selectedUserLinkedUserIds)) {
        return data;
    }

    const selectedUserLinkedUserIdSet = new Set(selectedUserLinkedUserIds);
    const allLinkedUserIds = new Set();

    // Collect all linked user IDs from the data and directly remove the selected user's linked user IDs
    data.forEach(user => {
        if (user && Array.isArray(user.linkedUserIds)) {
            user.linkedUserIds.forEach(linkedId => {
                if (!selectedUserLinkedUserIdSet.has(linkedId)) {
                    allLinkedUserIds.add(linkedId);
                }
            });
        }
    });

    // Filter the data to remove objects with IDs in allLinkedUserIds
    return data.filter(user => user && !allLinkedUserIds.has(user.id));
}
